<app-link [to]="to">
  <div class="card-product-small -title">
      <div>
        <h3>{{title}}</h3>
        <ng-content></ng-content>
      </div>
  </div>
</app-link>
